export default [
  {
    title: "Integration",
    customIcon: "CustomSVG",
    children: [
      {
        title: "CRM Logs List",
        route: "custom-module",
        path: "/custom-module/custom-integration-crm-logs-list",
      },
      {
        title: "POS Logs List",
        route: "custom-module",
        path: "/custom-module/custom-integration-pos-logs-list",
      },
      {
        title: "Transaction Logs List",
        route: "custom-module",
        path: "/custom-module/custom-integration-transaction-logs-list",
      },
    ],
  },
];
